var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5996 26.5463C23.3356 24.1343 21.2556 22.2569 18.7289 22.2569H12.6969C9.99295 22.2569 7.79961 24.4103 7.79961 27.0649V27.4769C5.60939 26.2127 3.79079 24.3939 2.52685 22.2035C1.2629 20.0132 0.598188 17.5285 0.599612 14.9996C0.599612 7.05028 7.03695 0.599609 14.9849 0.599609C22.9489 0.599609 29.3996 7.05028 29.3996 14.9996C29.3996 19.7249 27.1209 23.9196 23.5996 26.5463ZM15.0356 29.3996H14.9343H15.0356ZM14.9996 9.23961C14.2432 9.23961 13.4942 9.3886 12.7954 9.67806C12.0965 9.96753 11.4615 10.3918 10.9267 10.9267C10.3918 11.4615 9.96753 12.0965 9.67807 12.7954C9.3886 13.4942 9.23961 14.2432 9.23961 14.9996C9.23961 15.756 9.3886 16.505 9.67807 17.2039C9.96753 17.9027 10.3918 18.5377 10.9267 19.0725C11.4615 19.6074 12.0965 20.0317 12.7954 20.3212C13.4942 20.6106 14.2432 20.7596 14.9996 20.7596C16.5273 20.7596 17.9923 20.1528 19.0725 19.0725C20.1528 17.9923 20.7596 16.5273 20.7596 14.9996C20.7596 13.472 20.1528 12.0069 19.0725 10.9267C17.9923 9.84647 16.5273 9.23961 14.9996 9.23961Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.d7079e176e997e059ce601c68a062b09.svg";
export { ForwardRef as ReactComponent };